import React from "react";
import "./index.css";
import Header4 from "../../Header/Header4";
import { connect } from "react-redux";
import { Collapse, Progress, Tabs, Button, Pagination, Tooltip } from "antd";
import { CaretRightOutlined } from "@ant-design/icons";
import { useState, useEffect } from "react";
import axios from "axios";
import { SetInsClass, SetResourcePage } from "../../../store/actionCreators";
import { base64encode } from "../GeovisResource/service/actoin";

const { Panel } = Collapse;

const baseUrl =
  "https://caplos.aircas.ac.cn/gateway/api/online-school/collection";

const pagesize = 12;

const courseTypeName = {
  1: "共性技术研究",
  2: "数据应用示范",
  3: "推广应用案例",
  4: "PDF手册",
  5: "视频",
};

//TODO:仪器培训测试数据，随后改掉
const testToken =
  "NSE*1691564531943@6LQV_2000001828_6e2c22ef86494e3ab8f2174f1bddeb0e";
const testColumid = 123;

class OnlineTraining extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      commonData: [], //应用
      demData: [],
      popupData: [],
      showDetail: false,
      courseType: "1",
      userId: "",
      coursesLearned: [],
      coursesLearning: [],
      insPdfData: [],
      insMp4Data: [],
      curPage: undefined,
      learnedCourseNum: 0,
      learningCourseNum: 0,
      curPageLearned: 1,
      curPageLearning: 1,
    };
    this.curPage = undefined;
    this.pageSize = 4;
  }

  /**
   * 用于跳转至某一具体的课程界面
   * @param courseId
   * @param {number} curPage
   */
  courseDetailPreview = (courseId, curPage) => {
    let courseType = this.state.courseType;
    this.props.history.push({
      pathname: "/TrainingDetail",
      search: `?id=${courseId}`,
      state: { curPage: curPage, courseType: courseType },
    });
  };

  componentDidMount() {
    // console.log('detailstate', this.props.location.state);
    if (
      this.props.location.state &&
      this.props.location.state.curPage &&
      this.props.location.state.courseType
    ) {
      let curState = this.props.location.state;
      this.setState({
        courseType: curState.courseType,
        showDetail: true,
        curPage: curState.curPage,
      });
    }
    // 获取用户已经学完和正在学习的数据
    let timer = setInterval(() => {
      if (this.props.user && this.props.user.userId) {
        this.setState({ userId: this.props.user.userId });
        axios
          .get(
            global.url.px +
            `/collection/progress/page1?limit=${this.pageSize}&page=1&userId=${this.props.user.userId}`
          )
          .then((Response) => {
            this.setState({
              coursesLearned: Response.data.data.records,
              learnedCourseNum: Response.data.data.total,
            });
          });
        axios
          .get(
            global.url.px +
            `/collection/progress/page2?limit=${this.pageSize}&page=1&userId=${this.props.user.userId}`
          )
          .then((Response) => {
            this.setState({
              coursesLearning: Response.data.data.records,
              learningCourseNum: Response.data.data.total,
            });
          });
        clearInterval(timer);
      }
    }, 200);

    // // 获取仪器培训相关数据
    // axios.get(`/XingQiu/space/twelveFive/user/info?token=${testToken}`).then(r => {
    //     if (r.data.code === 0) {
    //         axios.get(`/XingQiu/space/supervise/base/contentinfoListByColumnid?token=${testToken}&columind=${testColumid}`).then(response => {
    //             // console.log('仪器培训:', response.data.data.rows);
    //             let data = res.0[], mp4Data = [];
    //             data.forEach(course => {
    //                 if (course.type === 'pdf') {
    //                     pdfData.push(course);
    //                 } else if (course.type === 'mp4') {
    //                     mp4Data.push(course);
    //                 }556
    //             })
    //             this.setState({insPdfData: pdfData, insMp4Data: mp4Data});
    //         })
    //     }
    // })

    this.getApplicationTraining();
  }

  getApplicationTraining = () => {
    // 获取应用培训相关数据
    axios.get(global.url.px + "/collection/getbytag").then((response) => {
      if (response.data.code === "200") {
        const {
          1: commonData,
          2: demData,
          3: popupData,
        } = response.data.payload;
        this.setState({
          commonData: commonData,
          demData: demData,
          popupData: popupData,
        });
      }
    });
  };

  getInstrumentTraining = () => {
    console.log(this.props.user);
    axios
      .get(
        "/gateway/api/interface/space/supervise/field/contentInfo/selectContentInfo",
        {
          headers: {
            Authorization: this.props.user.token,
          },
        }
      )
      .then((res) => {
        let data = res.data.data;
        let pdfData = [],
          mp4Data = [];
        data.forEach((course) => {
          if (course.type === "pdf") {
            pdfData.push(course);
          } else if (course.type === "mp4") {
            mp4Data.push(course);
          }
        });
        this.setState({ insPdfData: pdfData, insMp4Data: mp4Data });
        console.log(this.state.insPdfData, this.state.insMp4Data);
      });
  };

  /**
   * 控制是否展示某一类型标签的
   * @param {string} type -标签类型，见courseTypeName全局变量
   */
  handleShowDetail = (type) => {
    this.setState((prevState) => {
      let newTag = !prevState.showDetail;
      return { showDetail: newTag, courseType: type, curPage: 1 };
    });
  };

  /**
   * 构建正在学习中课程
   * @returns {Element[]}
   */
  buildCourseLearning = () => {
    return this.state.coursesLearning.map((course) => (
      <div
        key={course.collectionId}
        className="user_course_card user_course_card_hoverble"
        onClick={() => this.courseDetailPreview(course.collectionId)}
      >
        <img
          className="user_course_image"
          src={course.collectionCoverUrl}
          alt={"课程图片"}
        />
        <div className="user_course_detail">
          <div className="user_course_name_font">{course.collectionName}</div>
          <div className="user_course_progress_box">
            <div className="user_course_progress_box">
              已学{course.visitedCount}课时 / {course.resourcesCount}课时
            </div>
            <Progress
              percent={(course.visitedCount / course.resourcesCount) * 100}
              showInfo={false}
            />
          </div>
        </div>
      </div>
    ));
  };

  /**
   * 构建已学完课程卡片
   * @returns {Element[]}
   */
  buildCourseLearned = () => {
    // console.log('this.state.coursesLearned:', this.state.coursesLearned);
    return this.state.coursesLearned.map((course) => (
      <div
        key={course.collectionId}
        className="user_course_card user_course_card_hoverble"
        onClick={() => this.courseDetailPreview(course.collectionId)}
      >
        <img
          className="user_course_image"
          src={course.collectionCoverUrl}
          alt={"课程图片"}
        />
        <div className="user_course_detail">
          <div className="user_course_name_font">{course.collectionName}</div>
          <div className="user_course_finished_box">
            <svg
              className="date_icon_size"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 12 12"
              fill="none"
            >
              <g clipPath="url(#clip0_5813_11388)">
                <path
                  d="M6 0.75C3.10313 0.75 0.75 3.10313 0.75 6C0.75 8.89688 3.10313 11.25 6 11.25C8.89688 11.25 11.25 8.89688 11.25 6C11.25 3.10313 8.89688 0.75 6 0.75ZM8.24063 7.82812L5.72812 6.375H5.625V3H6.375V5.8875L8.61563 7.18125L8.24063 7.82812Z"
                  fill="#595959"
                />
              </g>
              <defs>
                <clipPath id="clip0_5813_11388">
                  <rect width="12" height="12" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <div className="finished_date_font">
              {course.modifiedTime.slice(0, 10)} 学完
            </div>
          </div>
          <div className="user_course_progress_box">
            共{course.resourcesCount}课时
          </div>
        </div>
      </div>
    ));
  };

  /**
   * 构建仪器培训课程的总览首页的卡片内容
   * @param {string} type
   * @returns {[Element]}
   */
  buildAllInsCourse = (type) => {
    let buildInsCards = (course) => {
      let imageUrl =
        course.attachmentsList.length === 0
          ? require("./images/所有课程图片.png")
          : "https://landv.aircas.ac.cn:10088/space/static/" +
          course.attachmentsList[0].url;
      return (
        <Tooltip key={course.id} placement="top" title={"点击后查看"}>
          <div
            className="all_course_card all_course_card_hoverable"
            onClick={() => this.onlinePreview(course.url)}
          >
            <img
              className="all_course_image"
              src={imageUrl}
              alt={"正在加载图片"}
            />
            <div className="all_course_name_font">{course.title} </div>
            <div className="all_course_info">
              <div className="icon_font_box">
                {/* <div className="icon_font">{course.releaseDate}</div> */}
              </div>
              <div
                className="begin_learning_button"
                style={{ justifyContent: "center" }}
              >
                <div className="begin_learning_font">
                  {course.type == "mp4" ? "播放" : "预览"}
                </div>
              </div>
            </div>
          </div>
        </Tooltip>
      );
    };

    let res = {
      PDF: this.state.insPdfData.map((course) => buildInsCards(course)),
      MP4: this.state.insMp4Data.map((course) => buildInsCards(course)),
    };
    return res[type].slice(0, 8);
  };

  onlinePreview = (url) => {
    let path = "https://landv.aircas.ac.cn:10088/space/static" + url;

    window.open(
      global.support.filePreview +
      "/onlinePreview?url=" +
      encodeURIComponent(global.Base64.encode(path)),
      "_blank"
    );
  };

  /**
   * 构造线上学习首页应用培训的所有卡片
   * @param {string} type -["1":共性技术研究,"2":数据应用示范,"3":应用推广案例]
   * @returns {Element[]}
   */
  buildAllCourse = (type) => {
    let buildCards = (course) => {
      return (
        <div
          key={course.collectionId}
          className="all_course_card all_course_card_hoverable"
          onClick={() => this.courseDetailPreview(course.collectionId)}
        >
          <img
            className="all_course_image"
            src={course.collectionCoverUrl}
            alt={"正在加载图片"}
          />
          <div className="all_course_name_font">{course.collectionName} </div>
          <div className="all_course_info">
            <div className="user_course_progress_box">
              共{course.resourceCount}课时
            </div>
            <div className="begin_learning_button">
              <svg
                className="icon_size"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 16 17"
                fill="none"
              >
                <path d="M5 5.5H10V6.5H5V5.5Z" fill="white" />
                <path d="M11 7.5H5V8.5H11V7.5Z" fill="white" />
                <path d="M5 9.5H8V10.5H5V9.5Z" fill="white" />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M13 4C13 3.44772 12.5523 3 12 3H4C3.44772 3 3 3.44771 3 4V13C3 13.5523 3.44772 14 4 14H10L13 11V4ZM12 4H4V13H9V11C9 10.4477 9.44772 10 10 10H12V4ZM11.5858 11H10V12.5858L11.5858 11Z"
                  fill="white"
                />
              </svg>
              <div className="begin_learning_font">开始学习</div>
            </div>
          </div>
        </div>
      );
    };

    let typeCourses = {
      1: this.state.commonData.map((course) => buildCards(course)),
      2: this.state.demData.map((course) => buildCards(course)),
      3: this.state.popupData.map((course) => buildCards(course)),
    };
    return typeCourses[type];
  };

  handleLearnedPageChange = (page) => {
    this.setState({ curPageLearned: page });
    axios
      .get(
        global.url.px +
        `/collection/progress/page1?limit=${this.pageSize}&page=${page}&userId=${this.props.user.userId}`
      )
      .then((Response) => {
        console.log("Response1:", Response);
        this.setState({ coursesLearned: Response.data.data.records });
      });
  };

  handleLearningPageChange = (page) => {
    this.setState({
      curPageLearning: page,
    });
    axios
      .get(
        global.url.px +
        `/collection/progress/page2?limit=${this.pageSize}&page=${page}&userId=${this.props.user.userId}`
      )
      .then((Response) => {
        this.setState({ coursesLearning: Response.data.data.records });
      });
  };
  handleTabChange = (e) => {
    if (e == 1) {
      this.getApplicationTraining();
    } else {
      this.getInstrumentTraining();
    }
  };

  render() {
    return (
      <>
        <Header4 />
        <div className="online_training_background">
          <div className="main_content">
            <div className="user_courses_container">
              <Collapse
                expandIcon={({ isActive }) => (
                  <CaretRightOutlined rotate={isActive ? 90 : 0} />
                )}
                bordered={false}
                expandIconPosition={"right"}
                defaultActiveKey={[1, 2]}
                ghost
              >
                <Panel
                  className="user_courses_header"
                  key={1}
                  header={
                    <div className="user_course_header_container">
                      <span className="user_courses_header_font">
                        正在学的课程
                      </span>
                      <span className="course_count_font">
                        共{this.state.learningCourseNum}个
                      </span>
                    </div>
                  }
                >
                  <div className="user_courses_box">
                    {this.buildCourseLearning()}
                    {this.state.learningCourseNum > this.pageSize ? (
                      <Pagination
                        simple={true}
                        total={this.state.learningCourseNum}
                        pageSize={this.pageSize}
                        current={this.state.curPageLearning}
                        onChange={this.handleLearningPageChange}
                      />
                    ) : null}
                  </div>
                </Panel>
                <Panel
                  className="user_courses_header"
                  key={2}
                  header={
                    <div className="user_course_header_container">
                      <span className="user_courses_header_font">
                        已学完的课程
                      </span>
                      <span className="course_count_font">
                        共{this.state.learnedCourseNum}个
                      </span>
                    </div>
                  }
                >
                  <div className="user_courses_box">
                    {this.buildCourseLearned()}
                    {this.state.learnedCourseNum > this.pageSize ? (
                      <Pagination
                        simple={true}
                        total={this.state.learnedCourseNum}
                        pageSize={this.pageSize}
                        current={this.state.curPageLearned}
                        onChange={this.handleLearnedPageChange}
                      />
                    ) : null}
                  </div>
                </Panel>
              </Collapse>
            </div>
            <div className="all_course_container">
              {this.state.showDetail ? (
                <TypeDetail
                  type={this.state.courseType}
                  toPrevPage={this.handleShowDetail}
                  toDetailPage={this.courseDetailPreview}
                  currentPage={this.state.curPage}
                  token={this.props.user.token}
                />
              ) : (
                <Tabs
                  className="tab_header_style"
                  defaultValues={1}
                  onChange={this.handleTabChange}
                >
                  <Tabs.TabPane tab="应用培训" key={1}>
                    <div className="all_course_body">
                      <div className="type_courses_panel">
                        <div className="course_type_title_container">
                          <div className="all_course_type_header">
                            <div className="course_type_title_font">
                              共性技术研究
                            </div>
                            <Button
                              type="link"
                              className="expand_button"
                              onClick={() => {
                                this.handleShowDetail("1");
                              }}
                            >
                              更多
                            </Button>
                          </div>
                          <div className="all_course_cards_container">
                            {this.buildAllCourse("1")}
                          </div>
                        </div>
                      </div>
                      <div className="type_courses_panel">
                        <div className="course_type_title_container">
                          <div className="all_course_type_header">
                            <div className="course_type_title_font">
                              数据应用示范
                            </div>
                            <Button
                              type="link"
                              className="expand_button"
                              onClick={() => this.handleShowDetail("2")}
                            >
                              更多
                            </Button>
                          </div>
                          <div className="all_course_cards_container">
                            {this.buildAllCourse("2")}
                          </div>
                        </div>
                      </div>
                      <div className="type_courses_panel">
                        <div className="course_type_title_container">
                          <div className="all_course_type_header">
                            <div className="course_type_title_font">
                              应用推广案例
                            </div>
                            <Button
                              type="link"
                              className="expand_button"
                              onClick={() => this.handleShowDetail("3")}
                            >
                              更多
                            </Button>
                          </div>
                          <div className="all_course_cards_container">
                            {this.buildAllCourse("3")}
                          </div>
                        </div>
                      </div>
                    </div>
                  </Tabs.TabPane>
                  <Tabs.TabPane tab="仪器培训" key={2}>
                    <div className="all_course_body">
                      <div className="type_courses_panel">
                        <div className="course_type_title_container">
                          <div className="all_course_type_header">
                            <div className="course_type_title_font">
                              PDF手册
                            </div>
                            <Button
                              type="link"
                              className="expand_button"
                              onClick={() => this.handleShowDetail("4")}
                            >
                              更多
                            </Button>
                          </div>
                          <div className="all_course_cards_container">
                            {this.buildAllInsCourse("PDF")}
                          </div>
                        </div>
                      </div>
                      <div className="type_courses_panel">
                        <div className="course_type_title_container">
                          <div className="all_course_type_header">
                            <div className="course_type_title_font">视频</div>
                            <Button
                              type="link"
                              className="expand_button"
                              onClick={() => this.handleShowDetail("5")}
                            >
                              更多
                            </Button>
                          </div>
                          <div className="all_course_cards_container">
                            {this.buildAllInsCourse("MP4")}
                          </div>
                        </div>
                      </div>
                    </div>
                  </Tabs.TabPane>
                </Tabs>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}

/**
 * 类型详情界面(函数组件)
 * @param {string} type -用于指明当前需要渲染的类型
 * @param {function} toPrevPage -用于返回页面的回调函数
 * @param {function} toDetailPage -用于跳转至详情界面
 * @param {number} curPage -用于指定当前页面
 * @constructor
 */
function TypeDetail({ type, toPrevPage, toDetailPage, currentPage, token }) {
  const [appCardsData, setAppCardsData] = useState([]);
  const [curPage, setCurPage] = useState(1);
  const [dataNum, setDataNum] = useState(0);
  const [insPdfCards, setInsPdfCards] = useState([]);
  const [insMp4Cards, setInsMp4Cards] = useState([]);

  useEffect(() => {
    if (currentPage) {
      setCurPage(currentPage);
    }
    if ("123".includes(type)) {
      axios
        .get(
          global.url.px +
          `/collection/page?page=${currentPage ? currentPage : curPage
          }&limit=${pagesize}&tag=${type}`
        )
        .then((response) => {
          if (response.data.code === 200) {
            const { records: cardsData, total: dataNum } = response.data.data;
            console.log("cardsData:", cardsData);
            setAppCardsData(cardsData);
            setDataNum(dataNum);
          }
        });
    } else {
      console.log("curType:", type);
      axios
        .get(
          "/gateway/api/interface/space/supervise/field/contentInfo/selectContentInfo",
          {
            headers: {
              Authorization: token,
            },
          }
        )
        .then((response) => {
          console.log("仪器培训类型详情:", response.data.data.rows);
          let cardsData = response.data.data;
          let pdfData = [],
            mp4Data = [];
          cardsData.forEach((course) => {
            if (course.type === "pdf") {
              pdfData.push(course);
            } else if (course.type === "mp4") {
              mp4Data.push(course);
            }
          });
          // setInsPdfCards(Array.from({length:10}).flatMap(()=>[...pdfData]));
          pdfData = Array.from({ length: 10 }).flatMap(() => [...pdfData]);
          setInsPdfCards(pdfData);
          setInsMp4Cards(mp4Data);
          let total = type === "4" ? pdfData.length : mp4Data.length;
          setDataNum(total);
        });
    }
  }, []);

  /**
   * 构造仪器培训相关类型详情（PDF，MP4）卡片
   * @returns {[Element]}
   */
  const buildInsCards = () => {
    let resCards = [],
      tempcards = [];
    if (type === "4") {
      tempcards = insPdfCards;
    } else if (type === "5") {
      tempcards = insMp4Cards;
    }
    let start = (curPage - 1) * pagesize;
    for (let i = start; i < start + pagesize && i < tempcards.length; i++) {
      let course = tempcards[i];
      let imageUrl =
        course.attachmentsList.length === 0
          ? require("./images/所有课程图片.png")
          : "https://landv.aircas.ac.cn:10088/space/static/" +
          course.attachmentsList[0].url;
      resCards.push(
        <Tooltip key={course.id} placement="top" title={"点击后查看"}>
          <div
            className="all_course_card all_course_card_hoverable"
            onClick={() =>
              window.open(
                global.support.filePreview +
                "/onlinePreview?url=" +
                encodeURIComponent(global.Base64.encode("https://landv.aircas.ac.cn:10088/space/static/" + course.url)),
                "_blank"
              )
            }
          >
            <img
              className="all_course_image"
              src={imageUrl}
              alt={"正在加载图片"}
            />
            <div className="all_course_name_font">{course.title} </div>
            <div className="user_course_finished_box">
              <svg
                className="date_icon_size"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 12 12"
                fill="none"
              >
                <g clipPath="url(#clip0_5813_11388)">
                  <path
                    d="M6 0.75C3.10313 0.75 0.75 3.10313 0.75 6C0.75 8.89688 3.10313 11.25 6 11.25C8.89688 11.25 11.25 8.89688 11.25 6C11.25 3.10313 8.89688 0.75 6 0.75ZM8.24063 7.82812L5.72812 6.375H5.625V3H6.375V5.8875L8.61563 7.18125L8.24063 7.82812Z"
                    fill="#595959"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_5813_11388">
                    <rect width="12" height="12" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <div className="finished_date_font">{course.releaseDate}</div>
            </div>
            <div className="all_course_info">
              <div className="icon_font_box"></div>
              <div
                className="begin_learning_button"
                style={{ justifyContent: "center" }}
              >
                <div className="begin_learning_font">
                  {course.type == "mp4" ? "播放" : "预览"}
                </div>
              </div>
            </div>
          </div>
        </Tooltip>
      );
    }
    return resCards;
  };

  const buildCards = () => {
    return appCardsData.map((course) => (
      <div
        key={course.collectionId}
        className="all_course_card all_course_card_hoverable"
        onClick={() => toDetailPage(course.collectionId, curPage)}
      >
        <img
          className="all_course_image"
          src={course.collectionCoverUrl}
          alt={"正在加载图片"}
        />
        <div className="all_course_name_font">{course.collectionName} </div>
        <div className="all_course_info">
          <div className="user_course_progress_box">
            共{course.resourceCount}课时
          </div>
          <div className="begin_learning_button">
            <svg
              className="icon_size"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 16 17"
              fill="none"
            >
              <path d="M5 5.5H10V6.5H5V5.5Z" fill="white" />
              <path d="M11 7.5H5V8.5H11V7.5Z" fill="white" />
              <path d="M5 9.5H8V10.5H5V9.5Z" fill="white" />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13 4C13 3.44772 12.5523 3 12 3H4C3.44772 3 3 3.44771 3 4V13C3 13.5523 3.44772 14 4 14H10L13 11V4ZM12 4H4V13H9V11C9 10.4477 9.44772 10 10 10H12V4ZM11.5858 11H10V12.5858L11.5858 11Z"
                fill="white"
              />
            </svg>
            <div className="begin_learning_font">开始学习</div>
          </div>
        </div>
      </div>
    ));
  };

  const handleBackPage = () => {
    toPrevPage();
  };

  const pageChange = (page) => {
    setCurPage(page);
    if ("123".includes(type)) {
      axios
        .get(
          global.url.px +
          `/collection/page?page=${page}&limit=${pagesize}&tag=${type}`
        )
        .then((response) => {
          if (response.data.code === 200) {
            const cardsData = response.data.data.records;
            setAppCardsData(cardsData);
          }
        });
    }
  };

  return (
    <>
      <div className="type_detail_header" onClick={handleBackPage}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.91421 8.24264L10.4497 4.70711L9.74264 4L5.5 8.24264L9.74264 12.4853L10.4497 11.7782L6.91421 8.24264Z"
            fill="#555555"
          />
        </svg>
        <div className="type_detail_font">{courseTypeName[type]}</div>
      </div>
      <div className="type_detail_body">
        <div className="type_courses_panel">
          <div className="course_type_title_container">
            <div className="all_course_cards_container">
              {"123".includes(type) ? buildCards() : buildInsCards()}
            </div>
          </div>
        </div>
        <div className="pagination_container">
          <Pagination
            showSizeChanger={false}
            defaultCurrent={1}
            total={dataNum}
            current={curPage}
            pageSize={12}
            onChange={pageChange}
          />
        </div>
      </div>
    </>
  );
}

const mapState = (state) => ({
  loginObj: state.userReducer.get("loginObj").toJS(),
  user: state.userReducer.get("user").toJS(),
});
const mapDispatch = (dispatch) => {
  return {
    setResourcePage: (collectionObj) => {
      dispatch(SetResourcePage(collectionObj));
    },
    setInsClass: (classObj) => {
      dispatch(SetInsClass(classObj));
    },
  };
};

export default connect(mapState, mapDispatch)(OnlineTraining);
